import { Menu, MUIcon } from '@platform/shared/ui';
import { ProjectTypes } from '@platform/types';
import React, { useEffect, useState } from 'react';
import MenuItem from '../WorkingLayerMenuItem';
import MenuTrigger from '../WorkingLayerMenuTrigger';

interface Props {
  workingLayer: ProjectTypes.SocialExplorerWorkingLayer;
  onRemove: (workingLayer: ProjectTypes.AnyWorkingLayer) => void;
  onBeingEdited?: (edited: boolean) => void;
}

const SocialExplorerWorkingLayerMenu: React.FC<Props> = ({ workingLayer, onRemove, onBeingEdited }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    onBeingEdited?.(isOpen);
  }, [isOpen]);

  return (
    <Menu
      visible={isOpen}
      onToggleVisibility={setIsOpen}
      trigger={<MenuTrigger />}
      hAlignment="right"
      menuClasses="py-0 mt-2"
    >
      <div className="flex w-[335px] flex-col gap-2 pt-4 pb-2">
        <MenuItem icon={<MUIcon name="delete" />} onClick={() => onRemove(workingLayer)}>
          Remove
        </MenuItem>
      </div>
    </Menu>
  );
};

export default SocialExplorerWorkingLayerMenu;
